import React from 'react';
import { Scale, FileCheck, Eye, Users } from 'lucide-react';

const PrinciplesSection = ({ isDarkMode }) => {
  const principles = [
    {
      icon: Scale,
      title: 'Truly Nonpartisan',
      description: 'No political agenda. No bias. Just facts about what\'s happening in your government.'
    },
    {
      icon: FileCheck,
      title: 'AI-Powered Summaries',
      description: 'Complex bills translated into plain English. Understand legislation in minutes, not hours.'
    },
    {
      icon: Eye,
      title: 'State & Local Coverage',
      description: 'Beyond federal politics. Track what\'s happening in your state legislature and city council where decisions directly impact your daily life.'
    },
    {
      icon: Users,
      title: 'Built for Citizens',
      description: 'Designed for regular people, not lobbyists or political insiders. Accessible, clear, and easy to use.'
    }
  ];

  return (
    <section className="bg-[#3b82f6] py-11 md:py-11">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-12 md:mb-16 text-left">
          What Makes Us<br />Different
        </h2>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {principles.map((principle, index) => {
            const Icon = principle.icon;
            return (
              <div key={index} className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-3">
                    {principle.title}
                  </h3>
                  <p className="text-white text-base md:text-lg leading-relaxed">
                    {principle.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PrinciplesSection;
